import * as React from "react";
import styles = require("./style.less");

interface ActionListProps {
    actions: any[];
    center?: boolean;
}

const ActionList: React.StatelessComponent<ActionListProps> = props => {
    const centerStyle = props.center ? {justifyContent: "center"} : {};
    return <div className={styles.actionList} style={{centerStyle}}>
        {props.actions.map((action, index) => !action ? null : React.cloneElement(action, { ...action.props, key: index }))}
    </div>;
};

ActionList.displayName = "ActionList";

export default ActionList;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/ActionList/ActionList.tsx